'use client';

import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './types';
import { cn } from '../lib/utils';
export function IconLoadingSpinner(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("h-5 w-5 animate-spin text-white", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />;
    t3 = <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <svg className={t1} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">{t2}{t3}</svg>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}